import { useSearchParams } from "react-router-dom";
import AccessDeniedComponent from "./view";
const AccessDenied = ({ open = false }) => {
  const [searchParams] = useSearchParams();

  return (
    <AccessDeniedComponent
      isOpen={open}
      content={searchParams.get("error") || undefined}
    />
  );
};
export default AccessDenied;
